/*
 * Public API Surface of ngx-lib/core/common/pipes
 */
export * from './common-pipes';
